export enum SyncRules {
    AccessFormsModels = 'activities.access-forms-models',
}

export enum AsyncRules {
    AccessLessonList = 'activities.access-lessons-list',
    EditLesson = 'activities.edit-lesson',
    DuplicateLesson = 'activities.duplicate-lesson',
}
